import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UsersService } from './users.service';
import { GenericService, LoaderConfig, ErrorConfig } from './generic.service';
import { ServerResponse } from '../models/ServerResponse';
import { filter, Observable, Subject } from 'rxjs';
import { AssociationTicketData, CreateTicket, CreateTicketFileMessage, CreateTicketMessage, ITicketMessage, Ticket, TicketMessage, TicketTyping } from '../models/Ticket';
import { ISAPI, ISPagination, MVListingConfigs } from 'is-lib';
import { SignalRService } from './signalR.service';
import { Alert, AlertWithTimediff } from '../models/Alert';
import { AlertsService } from './alerts.service';

@Injectable({
    providedIn: 'root'
})
export class TicketsService {
    
    public newMessagesSubject$ = new Subject<TicketMessage>();

    constructor(private genericService: GenericService, private _user: UsersService, private _signalRService: SignalRService, private _alertService: AlertsService) {}

    //#region GET
    getTickets(filters?: MVListingConfigs, callLoader: boolean | LoaderConfig = false, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<Ticket[]>> {
        if (filters == null) {
            filters = new MVListingConfigs([], null, new ISPagination(10, 0))
        }
        return this.genericService.post(`${environment.apiUrl}ClientPortalUsers/${this._user.userCountryCode}/Mine/Tickets/Get`, filters, undefined, callLoader, undefined, errorConfig);
    }

    getTicketMessages(ticketId: number, callLoader: boolean | LoaderConfig = true, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<ITicketMessage[]>> {
        return this.genericService.get(`${environment.apiUrl}Tickets/${this._user.userCountryCode}/${ticketId}/Messages`, callLoader, undefined, undefined, errorConfig);
    }

    getTicketTypes(errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<TicketTyping[]>> {
        return this.genericService.get(`${environment.apiUrl}Tickets/${this._user.userCountryCode}/Types`, true, undefined, undefined, errorConfig);
    }

    getTicketTypeSubtypes(ticketTypeId: number, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<TicketTyping[]>> {
        return this.genericService.get(`${environment.apiUrl}Tickets/${this._user.userCountryCode}/Types/${ticketTypeId}/Subtypes`, true, undefined, undefined, errorConfig);
    }
    //#endregion

    //#region POST
    postTicket(body: CreateTicket, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any>> {
        return this.genericService.post(`${environment.apiUrl}Tickets/${this._user.userCountryCode}`, body, undefined, true, undefined, errorConfig)
    }

    postTicketMessage(ticketId: number, body: CreateTicketMessage, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any>> {
        return this.genericService.post(`${environment.apiUrl}Tickets/${this._user.userCountryCode}/${ticketId}/Message`, body, undefined, undefined, undefined, errorConfig)
    }

    postTicketMessageFile(ticketId: number, messageId: number, body: FormData, errorConfig?: ErrorConfig | boolean): Observable<ServerResponse<any>> {
        return this.genericService.post(`${environment.apiUrl}Tickets/${this._user.userCountryCode}/${ticketId}/Message/${messageId}/File`, body, undefined, undefined, undefined, errorConfig)
    }
    //#endregion

    //#region PATCH
    associateTicketToEntity(entityId: string, ticketId: string, errorConfig?: ErrorConfig | boolean) {
        return this.genericService.patch(`${environment.apiUrl}Entities/${this._user.userCountryCode}/${entityId}/Ticket/${ticketId}/Associate`, undefined, undefined, true, undefined, errorConfig)
    }

    associateTicketToElectricitySupplyContract(electricitySupplyContractId: string, ticketId: string, errorConfig?: ErrorConfig | boolean) {
        return this.genericService.patch(`${environment.apiUrl}ElectricitySupplyContracts/${this._user.userCountryCode}/${electricitySupplyContractId}/Ticket/${ticketId}/Associate`, undefined, undefined, true, undefined, errorConfig)
    }

    associateTicketToNaturalGasSupplyContract(naturalGasSupplyContractId: string, ticketId: string, errorConfig?: ErrorConfig | boolean) {
        return this.genericService.patch(`${environment.apiUrl}NaturalGasSupplyContracts/${this._user.userCountryCode}/${naturalGasSupplyContractId}/Ticket/${ticketId}/Associate`, undefined, undefined, true, undefined, errorConfig)
    }

    associateTicketToContract(contractId: string, ticketId: string, errorConfig?: ErrorConfig | boolean) {
        return this.genericService.patch(`${environment.apiUrl}Contracts/${this._user.userCountryCode}/${contractId}/Ticket/${ticketId}/Associate`, undefined, undefined, true, undefined, errorConfig)
    }
    //#endregion
}